import { Component, EventEmitter, Input, Output } from '@angular/core';

import { RemoveButtonStyle } from './remove-button-style';

@Component({
    selector: 'bs-digital-pick-remove-button',
    templateUrl: './pick-remove-button.component.html',
    styleUrls: ['./pick-remove-button.component.scss'],
    standalone: false,
})
export class PickRemoveButtonComponent {
    @Output() remove = new EventEmitter<any>();
    @Input() removeButtonStyle: RemoveButtonStyle;
    constructor() {}
    get removeButtonClass(): string {
        if (this.removeButtonStyle === RemoveButtonStyle.Close) {
            return 'theme-close';
        }

        return 'theme-ex';
    }

    clickRemovePick(): void {
        this.remove.emit();
    }
}
